<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="recordId" >
        <span slot="label" ><a-tooltip>{{$t('关联中奖记录')}}<template slot="title">{{$t('关联中奖记录')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.recordId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'关联中奖记录'" />
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" ><a-tooltip>{{$t('')}}<template slot="title">{{$t('')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.userId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+''" />
      </a-form-model-item>
      <a-form-model-item prop="receiverName" >
        <span slot="label" ><a-tooltip>{{$t('收货人')}}<template slot="title">{{$t('收货人')}}</template></a-tooltip> </span>
        <a-input v-model="form.receiverName" :maxLength="50" :placeholder="$t('请输入')+'收货人'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="phone" >
        <span slot="label" ><a-tooltip>{{$t('电话')}}<template slot="title">{{$t('电话')}}</template></a-tooltip> </span>
        <a-input v-model="form.phone" :maxLength="20" :placeholder="$t('请输入')+'电话'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="province" >
        <span slot="label" ><a-tooltip>{{$t('省')}}<template slot="title">{{$t('省')}}</template></a-tooltip> </span>
        <a-input v-model="form.province" :maxLength="50" :placeholder="$t('请输入')+'省'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="city" >
        <span slot="label" ><a-tooltip>{{$t('市')}}<template slot="title">{{$t('市')}}</template></a-tooltip> </span>
        <a-input v-model="form.city" :maxLength="50" :placeholder="$t('请输入')+'市'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="district" >
        <span slot="label" ><a-tooltip>{{$t('区')}}<template slot="title">{{$t('区')}}</template></a-tooltip> </span>
        <a-input v-model="form.district" :maxLength="50" :placeholder="$t('请输入')+'区'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="detailAddress" >
        <span slot="label" ><a-tooltip>{{$t('详细地址')}}<template slot="title">{{$t('详细地址')}}</template></a-tooltip> </span>
        <a-input v-model="form.detailAddress" :maxLength="255" :placeholder="$t('请输入')+'详细地址'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="postalCode" >
        <span slot="label" ><a-tooltip>{{$t('邮编')}}<template slot="title">{{$t('邮编')}}</template></a-tooltip> </span>
        <a-input v-model="form.postalCode" :maxLength="20" :placeholder="$t('请输入')+'邮编'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="createdAt" >
        <span slot="label" ><a-tooltip>{{$t('')}}<template slot="title">{{$t('')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.createdAt" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="updatedAt" >
        <span slot="label" ><a-tooltip>{{$t('')}}<template slot="title">{{$t('')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.updatedAt" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getLotteryAddress, addLotteryAddress, updateLotteryAddress } from '@/api/lottery/lotteryAddress'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
  import moment from 'moment';


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        recordId: null,
        userId: null,
        receiverName: null,
        phone: null,
        province: null,
        city: null,
        district: null,
        detailAddress: null,
        postalCode: null,
        createdAt: null,
        updatedAt: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        recordId: null,
        userId: null,
        receiverName: null,
        phone: null,
        province: null,
        city: null,
        district: null,
        detailAddress: null,
        postalCode: null,
        createdAt: null,
        updatedAt: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLotteryAddress({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateLotteryAddress(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addLotteryAddress(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
